export default "__VITE_ASSET__5I1hQqAo__"